module.exports = __webpack_public_path__ + "img/fruit-raspberries-190x100.5c4ed32c.jpg";